window.isMobile = window.matchMedia("(max-width: 768px)").matches;
gsap.registerPlugin(ScrollTrigger);

// section-1 桌面端逻辑
function section1Pc() {
  const textNode = document.querySelector(`[handle="section-1-texts"]`);

  // 窗口高度
  const innerHeight = window.innerHeight;
  // 导航栏高度
  const navBarHeight = 64;
  // 渲染内容的高度
  const contentHeight = innerHeight - navBarHeight;

  const imageHeight = window.innerHeight / 2;
  const textHeight = textNode.offsetHeight;

  const imageMiddleTop = Math.round((innerHeight - imageHeight) / 2);
  const textMiddleTop = Math.round((innerHeight - textHeight) / 2);

  const evenlyGap = Math.round((contentHeight - imageHeight - textHeight) / 3);
  const imageFinalTop = evenlyGap + navBarHeight;
  const textFinalTop = imageFinalTop + imageHeight + evenlyGap;

  gsap.set(`[handle="section-1-texts"]`, {
    top: textMiddleTop,
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-1"]`,
      start: "top top",
      end: `+=1800`,
      scrub: true,
      pin: true,
    },
  });

  tl.to(`[handle="section-1-overly"]`, {
    opacity: 0,
    ease: "none",
    duration: 0.3,
  })
    .to(`[handle="section-1-image"]`, {
      top: imageMiddleTop,
      width: 1112,
      height: imageHeight,
      ease: "none",
      duration: 0.3,
      borderRadius: 10,
    })
    .to(`[handle="section-1-image"]`, {
      top: imageFinalTop,
      ease: "none",
      duration: 0.2,
    })
    .to(
      `[handle="section-1-texts"]`,
      {
        opacity: 1,
        top: textFinalTop,
        color: "#000",
        ease: "none",
        duration: 0.4,
      },
      "-=0.3",
    )
    .to(`[handle="section-1-texts"]`, { duration: 0.1 });
}

// section-2 桌面端逻辑
function section2Pc() {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-2"]`,
      start: "top 50%",
      end: "top top",
      scrub: 1.2,
    },
  });
  tl.from(
    [
      `[handle="section-2-panel-1-title"]`,
      `[handle="section-2-panel-1-image"]`,
      `[handle="section-2-panel-1-subtitle"]`,
      `[handle="section-2-panel-1-desc"]`,
    ],
    {
      y: 120,
      opacity: 0,
      duration: 0.5,
      ease: "power3.out",
      stagger: 0.3,
    },
  );

  gsap
    .timeline({
      scrollTrigger: {
        trigger: `[handle="section-2"]`,
        start: "top top",
        end: "+=800",
        scrub: true,
        pin: true,
      },
    })
    .to({}, { duration: 0.1 })
    .to(`[handle="section-2-panel-1"]`, {
      x: "-100%",
      opacity: 0,
      ease: "none",
      duration: 0.8,
    })
    .to(
      `[handle="section-2-panel-2"]`,
      {
        x: "0%",
        ease: "none",
        duration: 0.8,
      },
      0,
    )
    .fromTo(
      `[handle="section-2-panel-2"]`,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        ease: "none",
        duration: 0.8,
      },
      0,
    )
    .to({}, { duration: 0.1 });
}

// section-3 桌面端逻辑
function section3Pc() {
  const section3Items = gsap.utils.toArray(`[handle="section-3-item"]`);
  const section3List = document.querySelector(`[handle="section-3-wrapper"]`);

  // 计算：让第 i 个元素“视觉居中”需要把 list 上移多少
  function centerOffset(i) {
    const el = section3Items[i];
    const listRect = section3List.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    const listCenter = listRect.top + listRect.height / 2;
    const elCenter = elRect.top + elRect.height / 2;

    // 需要移动的距离（负值表示向上）
    return -(elCenter - listCenter);
  }

  const offsets = section3Items.map((_, i) => centerOffset(i));

  // 先把第 0 个设为高亮
  gsap.set(section3List, { y: offsets[0] });
  section3Items.forEach((item, i) => {
    if (i !== 0) {
      gsap.set(item, { opacity: 0.2 });
    }
  });

  // // 主时间线
  const section3Timeline = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-3"]`,
      start: "top top",
      end: "+=1800", // 三段切换
      scrub: true,
      pin: true,
    },
  });

  // // 为了避免首帧测量不准，等一帧再算
  requestAnimationFrame(() => {
    section3Items.forEach((item, i) => {
      // 每一段的起点（均分时间轴）
      const pos = i; // 0,1,2...

      // 1) list 移动，让当前项居中
      section3Timeline.to(
        section3List,
        {
          y: offsets[i],
          ease: "none",
          duration: 0.8,
        },
        pos,
      );

      // 2) 当前项高亮
      section3Timeline.to(
        section3Items[i],
        {
          opacity: 1,
          ease: "none",
          duration: 0.8,
        },
        pos,
      );

      // 3) 其它项弱化（这里简单处理：把“上一个”降级）
      if (i > 0) {
        section3Timeline.to(
          section3Items[i - 1],
          {
            opacity: 0.2,
            ease: "none",
            duration: 0.8,
          },
          pos,
        );
      }
    });
  });
}

// section-4 桌面端逻辑
function section4Pc() {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-4"]`,
      start: "top 75%",
      end: "+=600px",
      scrub: 1.2,
    },
  });
  tl.from(
    [
      `[handle="section-4-title"]`,
      `[handle="section-4-desc"]`,
      `[handle="section-4-wrapper"]`,
    ],
    {
      y: 120,
      opacity: 0,
      duration: 0.5,
      ease: "power3.out",
      stagger: 0.3,
    },
  );
  // tl.from(
  //   `[handle="section-4-item"]`,
  //   {
  //     y: 120,
  //     opacity: 0,
  //     duration: 0.5,
  //     ease: "power3.out",
  //     stagger: 0.3,
  //   },
  //   "-=0.1",
  // );
}

// section-5 桌面端逻辑
function section5Pc() {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-5"]`,
      start: "top 40%",
      end: "+=200px",
      scrub: 1.2,
    },
  });
  tl.from(
    [
      `[handle="section-5-titl"]`,
      `[handle="section-5-dots"]`,
      `[handle="section-5-viewport"]`,
    ],
    {
      y: 120,
      opacity: 0,
      duration: 0.5,
      ease: "power3.out",
      stagger: 0.3,
    },
  );

  const emblaNode = document.querySelector(`[handle="section-5"]`);
  const viewportNode = emblaNode.querySelector(`[handle="section-5-viewport"]`);
  const nextbtnNode = emblaNode.querySelector(`[handle="section-5-next"]`);
  const prevbtnNode = emblaNode.querySelector(`[handle="section-5-prev"]`);

  const dotsNode = emblaNode.querySelector(`[handle="section-5-dots"]`);

  const addDotsClickHandlers = (emblaApi, dotsNode) => {
    if (dotsNode) {
      const dotNodes = Array.from(dotsNode.children);
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener("click", () => {
          emblaApi.goTo(index);
        });
      });
    }
  };

  const toggleDotsActive = (emblaApi, dotsNode) => {
    if (dotsNode) {
      const dotNodes = Array.from(dotsNode.children);
      dotNodes.forEach((dotNode, index) => {
        dotNode.classList.toggle("active", index === emblaApi.selectedSnap());
      });
    }
  };

  const addPrevNextBtnsClickHandlers = (emblaApi, prevbtnNode, nextbtnNode) => {
    if (prevbtnNode) {
      prevbtnNode.addEventListener("click", () => {
        emblaApi.goToPrev();
      });
    }
    if (nextbtnNode) {
      nextbtnNode.addEventListener("click", () => {
        emblaApi.goToNext();
      });
    }
  };

  const toggleArrowsDisabled = (emblaApi, prevbtnNode, nextbtnNode) => {
    if (prevbtnNode) {
      prevbtnNode.toggleAttribute("data-disabled", !emblaApi.canGoToPrev());
    }
    if (nextbtnNode) {
      nextbtnNode.toggleAttribute("data-disabled", !emblaApi.canGoToNext());
    }
  };

  const options = { duration: 30 };
  const plugins = [EmblaCarouselAutoplay({ delay: 3000 }), EmblaCarouselFade()];
  const emblaApi = EmblaCarousel(viewportNode, options, plugins);

  addPrevNextBtnsClickHandlers(emblaApi, prevbtnNode, nextbtnNode);
  toggleArrowsDisabled(emblaApi, prevbtnNode, nextbtnNode);
  addDotsClickHandlers(emblaApi, dotsNode);
  toggleDotsActive(emblaApi, dotsNode);

  emblaApi.on("select", () => {
    toggleArrowsDisabled(emblaApi, prevbtnNode, nextbtnNode);
    toggleDotsActive(emblaApi, dotsNode);
  });
  emblaApi.on("reinit", () => {
    toggleArrowsDisabled(emblaApi, prevbtnNode, nextbtnNode);
    toggleDotsActive(emblaApi, dotsNode);
  });
}

// section-6 桌面端逻辑
function section6Pc() {
  let currentIndex = -1;
  const items = gsap.utils.toArray(`[handle="section-6-item"]`);

  const prevbtnNode = document.querySelector(`[handle="section-6-prev"]`);
  const nextbtnNode = document.querySelector(`[handle="section-6-next"]`);
  const dotsNode = document.querySelector(`[handle="section-6-dots"]`);

  dotsNode.innerHTML = items.map(() => `<div class="dot"></div>`).join("");

  const descHeights = Array.from(items).map(
    (item) =>
      item.querySelector(`[handle="section-6-item-desc"]`)?.offsetHeight || 0,
  );

  const setCardActive = (index) => {
    items.forEach((item, i) => {
      const tl = gsap.timeline();

      const p = item.querySelector(`[handle="section-6-item-desc"]`);
      const cardText = item.querySelector(`[handle="section-6-item-texts"]`);
      const pHeight = descHeights[i];
      const cardTextHeight = cardText.offsetHeight;
      if (i === index) {
        tl.to(item, {
          width: 510,
          height: 540,
          duration: 0.5,
          ease: "power2.out",
        })
          .to(
            cardText,
            {
              y: cardTextHeight,
              opacity: 0,
              duration: 0.3,
              ease: "power2.out",
            },
            "-=0.5",
          )
          .to(cardText, { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" })
          .to(
            p,
            { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" },
            "-=0.2",
          );
      } else {
        tl.to(item, {
          width: 290,
          height: 340,
          duration: 0.5,
          ease: "power2.out",
        })
          .to(
            cardText,
            {
              y: cardTextHeight,
              opacity: 0,
              duration: 0.3,
              ease: "power2.out",
            },
            "-=0.5",
          )
          .to(cardText, {
            y: pHeight,
            opacity: 1,
            duration: 0.5,
            ease: "power2.out",
          })
          .to(
            p,
            { y: 20, opacity: 0, duration: 0.5, ease: "power2.out" },
            "-=0.5",
          );
      }
    });

    currentIndex = index;

    prevbtnNode.toggleAttribute("data-disabled", currentIndex === 0);
    nextbtnNode.toggleAttribute(
      "data-disabled",
      currentIndex === items.length - 1,
    );
    Array.from(dotsNode.children).forEach((dot, idx) => {
      dot.classList.toggle("active", idx === index);
    });
  };

  items.forEach((item) => {
    item.addEventListener("click", () => {
      const index = items.indexOf(item);
      setCardActive(index);
    });
  });
  setCardActive(0);

  prevbtnNode.addEventListener("click", () => {
    if (currentIndex > 0) {
      setCardActive(currentIndex - 1);
    }
  });
  nextbtnNode.addEventListener("click", () => {
    if (currentIndex < items.length - 1) {
      setCardActive(currentIndex + 1);
    }
  });

  Array.from(dotsNode.children).forEach((dot, index) => {
    dot.addEventListener("click", () => {
      setCardActive(index);
    });
  });
}

// section-7 桌面端逻辑
function section7Pc() {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-7"]`,
      start: "top 40%",
      end: "+=600px",
      scrub: 1.2,
    },
  });
  tl.from([`[handle="section-7-wrapper"]`, `[handle="section-7-title"]`], {
    y: 120,
    opacity: 0,
    duration: 0.5,
    ease: "power3.out",
    stagger: 0.3,
  });
  tl.from(`[handle="section-7-icon"]`, {
    y: 100,
    opacity: 0,
    duration: 0.5,
    ease: "power3.out",
    stagger: 0.3,
  });
}

// 移动端逻辑
function section1Mb() {
  const textNode = document.querySelector(`[handle="section-1-texts"]`);

  const innerHeight = window.innerHeight;
  const innerWidth = window.innerWidth;
  const aspectRatio = 1688 / 3000;
  const imageHeight = (innerWidth - 30) * aspectRatio;
  const textHeight = textNode.offsetHeight;
  const gap = 40;

  const imageHalfHeight = imageHeight / 2;
  const textHalfHeight = textHeight / 2;

  const imageMiddleTop = Math.round((innerHeight - imageHeight) / 2);
  const textMiddleTop = Math.round((innerHeight - textHeight) / 2);
  const navBarHeight = 44;

  gsap.set(`[handle="section-1-texts"]`, {
    top: textMiddleTop,
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-1"]`,
      start: "top top",
      end: `+=1800`,
      scrub: true,
      pin: true,
    },
  });

  tl.to(`[handle="section-1-overly"]`, {
    opacity: 0,
    ease: "none",
    duration: 0.3,
  })
    .to(`[handle="section-1-image"]`, {
      top: imageMiddleTop,
      height: imageHeight,
      ease: "none",
      duration: 0.3,
      borderRadius: 10,
    })
    .to(`[handle="section-1-image"]`, {
      top: imageMiddleTop - textHalfHeight - gap / 2 + navBarHeight,
      ease: "none",
      duration: 0.2,
    })
    .to(
      `[handle="section-1-texts"]`,
      {
        opacity: 1,
        top: textMiddleTop + imageHalfHeight + gap / 2 + navBarHeight,
        color: "#000",
        ease: "none",
        duration: 0.5,
      },
      "-=0.3",
    );
}

function section2Mb() {
  const tl1 = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-2-panel-1"]`,
      start: "top 60%",
      end: "+=50%",
      scrub: 1.2,
    },
  });

  tl1.from(
    [
      `[handle="section-2-panel-1-title"]`,
      `[handle="section-2-panel-1-image"]`,
      `[handle="section-2-panel-1-subtitle-mb"]`,
      `[handle="section-2-panel-1-desc-mb"]`,
    ],
    {
      y: 40,
      opacity: 0,
      duration: 1,
      stagger: 0.3,
      ease: "power2.out",
    },
  );

  const tl2 = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-2-panel-2"]`,
      start: "top 60%",
      end: "+=50%",
      scrub: 1.2,
    },
  });

  tl2.from(
    [
      `[handle="section-2-panel-2-title"]`,
      `[handle="section-2-panel-2-image"]`,
      `[handle="section-2-panel-2-subtitle-mb"]`,
      `[handle="section-2-panel-2-desc-mb"]`,
    ],
    {
      y: 40,
      opacity: 0,
      duration: 1,
      stagger: 0.3,
      ease: "power2.out",
    },
  );
}

function section3Mb() {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-3"]`,
      start: "top 50%",
      end: "+=50%",
      scrub: 1.2,
    },
  });

  tl.from(
    [
      `[handle="section-3-title"]`,
      `[handle="section-3-tabs"]`,
      `[handle="section-3-viewport"]`,
    ],
    {
      y: 60,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      stagger: 0.3,
    },
  );

  const emblaNode = document.querySelector(`[handle="section-3"]`);
  const viewportNode = emblaNode.querySelector(`[handle="section-3-viewport"]`);

  const options = { duration: 30 };
  const plugins = [EmblaCarouselAutoplay({ delay: 3000 }), EmblaCarouselFade()];
  const emblaApi = EmblaCarousel(viewportNode, options, plugins);
  const dotsNode = emblaNode.querySelector(`[handle="section-3-tabs"]`);

  emblaApi.plugins.autoplay?.play();

  const addTabClickHandlers = () => {
    Array.from(dotsNode.children).forEach((dot, index) => {
      dot.addEventListener("click", () => {
        emblaApi.goTo(index);
      });
    });
  };

  const toggleTabActive = () => {
    Array.from(dotsNode.children).forEach((dot, index) => {
      dot.classList.toggle("active", index === emblaApi.selectedSnap());
    });
  };

  toggleTabActive();
  addTabClickHandlers();
  emblaApi.on("select", toggleTabActive);
  emblaApi.on("reinit", toggleTabActive);
}

function section5Mb() {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-5"]`,
      start: "top 50%",
      end: "+=40%",
      scrub: 1.2,
    },
  });

  tl.from(
    [
      `[handle="section-5-titl"]`,
      `[handle="section-5-dots"]`,
      `[handle="section-5-viewport"]`,
    ],
    {
      y: 60,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      stagger: 0.3,
    },
  );

  const emblaNode = document.querySelector(`[handle="section-5"]`);
  const viewportNode = emblaNode.querySelector(`[handle="section-5-viewport"]`);

  const options = {};
  const plugins = [];
  const emblaApi = EmblaCarousel(viewportNode, options, plugins);
  const dotsNode = emblaNode.querySelector(`[handle="section-5-dots"]`);

  const nextbtnNode = emblaNode.querySelector(`[handle="section-5-next"]`);
  const prevbtnNode = emblaNode.querySelector(`[handle="section-5-prev"]`);

  emblaApi.plugins.autoplay?.play();

  const addPrevNextBtnsClickHandlers = () => {
    if (nextbtnNode) {
      nextbtnNode.addEventListener("click", () => {
        emblaApi.goToNext();
      });
    }
    if (prevbtnNode) {
      prevbtnNode.addEventListener("click", () => {
        emblaApi.goToPrev();
      });
    }
  };

  const addDotsClickHandlers = () => {
    Array.from(dotsNode.children).forEach((dot, index) => {
      dot.addEventListener("click", () => {
        emblaApi.goTo(index);
      });
    });
  };

  const toggleArrowsDisabled = () => {
    if (nextbtnNode) {
      nextbtnNode.toggleAttribute("data-disabled", !emblaApi.canGoToNext());
    }
    if (prevbtnNode) {
      prevbtnNode.toggleAttribute("data-disabled", !emblaApi.canGoToPrev());
    }
  };

  const toggleDotsActive = () => {
    Array.from(dotsNode.children).forEach((dot, index) => {
      dot.classList.toggle("active", index === emblaApi.selectedSnap());
    });
  };

  emblaApi.on("select", () => {
    toggleArrowsDisabled();
    toggleDotsActive();
  });
  emblaApi.on("reinit", () => {
    toggleArrowsDisabled();
    toggleDotsActive();
  });

  toggleDotsActive();
  addPrevNextBtnsClickHandlers();
  toggleArrowsDisabled();
  addDotsClickHandlers();
}

function section6Mb() {
  const viewportNode = document.querySelector(`[handle="section-6-viewport"]`);
  const options = {};
  const plugins = [];
  const emblaApi = EmblaCarousel(viewportNode, options, plugins);
  const dotsNode = document.querySelector(`[handle="section-6-dots"]`);
  const prevbtnNode = document.querySelector(`[handle="section-6-prev"]`);
  const nextbtnNode = document.querySelector(`[handle="section-6-next"]`);

  const items = gsap.utils.toArray(`[handle="section-6-item"]`);
  const descHeights = Array.from(items).map(
    (item) =>
      item.querySelector(`[handle="section-6-item-desc"]`)?.offsetHeight || 0,
  );

  dotsNode.innerHTML = items.map(() => `<div class="dot"></div>`).join("");

  const addPrevNextBtnsClickHandlers = () => {
    if (prevbtnNode) {
      prevbtnNode.addEventListener("click", () => {
        emblaApi.goToPrev();
      });
    }
    if (nextbtnNode) {
      nextbtnNode.addEventListener("click", () => {
        emblaApi.goToNext();
      });
    }
  };

  const toggleArrowsDisabled = () => {
    if (prevbtnNode) {
      prevbtnNode.toggleAttribute("data-disabled", !emblaApi.canGoToPrev());
    }
    if (nextbtnNode) {
      nextbtnNode.toggleAttribute("data-disabled", !emblaApi.canGoToNext());
    }
  };

  const toggleDotsActive = () => {
    Array.from(dotsNode.children).forEach((dot, index) => {
      dot.classList.toggle("active", index === emblaApi.selectedSnap());
    });
  };

  const addDotsClickHandlers = () => {
    Array.from(dotsNode.children).forEach((dot, index) => {
      dot.addEventListener("click", () => {
        emblaApi.goTo(index);
      });
    });
  };

  const setCardActive = (index) => {
    items.forEach((item, i) => {
      const tl = gsap.timeline();
      const p = item.querySelector(`[handle="section-6-item-desc"]`);
      const cardText = item.querySelector(`[handle="section-6-item-texts"]`);
      const pHeight = descHeights[i];
      const cardTextHeight = cardText.offsetHeight;

      const activeWidth = window.innerWidth - 60;
      const activeHeight = (activeWidth * 386) / 334;
      const normalWidth = (64.3 * window.innerWidth) / 100;
      const normalHeight = (normalWidth * 294) / 254;

      if (i === index) {
        tl.to(item, {
          width: activeWidth,
          height: activeHeight,
          duration: 0.5,
          ease: "power2.out",
        })
          .to(
            cardText,
            {
              y: cardTextHeight,
              opacity: 0,
              duration: 0.3,
              ease: "power2.out",
            },
            "-=0.5",
          )
          .to(cardText, { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" })
          .to(
            p,
            { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" },
            "-=0.2",
          );
      } else {
        tl.to(item, {
          width: normalWidth,
          height: normalHeight,
          duration: 0.5,
          ease: "power2.out",
        })
          .to(
            cardText,
            {
              y: cardTextHeight,
              opacity: 0,
              duration: 0.3,
              ease: "power2.out",
            },
            "-=0.5",
          )
          .to(cardText, {
            y: pHeight,
            opacity: 1,
            duration: 0.5,
            ease: "power2.out",
          })
          .to(
            p,
            { y: 20, opacity: 0, duration: 0.5, ease: "power2.out" },
            "-=0.5",
          );
      }
    });
  };

  toggleDotsActive();
  addPrevNextBtnsClickHandlers();
  toggleArrowsDisabled();
  addDotsClickHandlers();

  emblaApi.on("select", () => {
    const index = emblaApi.selectedSnap();
    toggleArrowsDisabled();
    toggleDotsActive();
    const timer = setTimeout(() => {
      setCardActive(index);
      clearTimeout(timer);
    }, 300);
  });
  emblaApi.on("reinit", () => {
    toggleArrowsDisabled();
    toggleDotsActive();
  });
}

function section7Mb() {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `[handle="section-7"]`,
      start: "top 40%",
      end: "+=400",
      scrub: 1.2,
    },
  });
  tl.from([`[handle="section-7-wrapper"]`, `[handle="section-7-title"]`], {
    y: 60,
    opacity: 0,
    duration: 0.5,
    ease: "power3.out",
    stagger: 0.3,
  });
  tl.from(`[handle="section-7-icon"]`, {
    y: 60,
    opacity: 0,
    duration: 0.5,
    ease: "power3.out",
    stagger: 0.3,
  });
}

// 桌面端逻辑
if (!window.isMobile) {
  section1Pc();
  section2Pc();
  section3Pc();
  section4Pc();
  section5Pc();
  section6Pc();
  section7Pc();
} else {
  section1Mb();
  section2Mb();
  section3Mb();
  section5Mb();
  section6Mb();
  section7Mb();
}
